export const marketingNavLinks = [
  { label: "PMS", target: "TeamBoard", route: "/" },
  { label: "Features", target: "features", route: "/features" },
  { label: "Why PMS", target: "why-teamboard", route: "/why-teamboard" },
  { label: "Pricing", target: "pricing", route: "/pricing" },
  { label: "Testimonials", target: "testimonials", route: "/testimonials" },
  // { label: "Changelog", target: "changelog", route: "/changelog" },
  // { label: "Security", target: "security", route: "/security" },
  // { label: "Blog", target: "blog", route: "/blog" },
  // { label: "Help Center", target: "help", route: "/help" },
  // { label: "About Us", target: "about-us", route: "/about-us" },
  // { label: "Careers", target: "careers", route: "/careers" },
  { label: "FAQ", target: "faq", route: "/faq" },
  { label: "Contact Us", target: "contact", route: "/contact" },
];
